export default {
  resetAccount: 'Reset LoanBuilder Account',
  createAccount: 'Create LoanBuilder Account',
};
